var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderNo"},[_c('div',{staticStyle:{"color":"#1E3C3E","margin-right":"0.2rem"}},[_vm._v(_vm._s(_vm.orderNo))]),_c('van-image',{attrs:{"width":"20","height":"20","src":require('@/assets/order/copy.png')},on:{"click":function($event){$event.stopPropagation();return _vm.handleCopy.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }